import { render, staticRenderFns } from "./DocumentVerification.vue?vue&type=template&id=aed1090a&scoped=true&"
import script from "./DocumentVerification.vue?vue&type=script&lang=js&"
export * from "./DocumentVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed1090a",
  null
  
)

export default component.exports